import './NotificationsPage.css';

const NotificationsPage = () => {
  return (
    <div className="room-settings-page notifications-page">
      <div className="room-settings-section">
        <h3 className="room-settings-section-title">Notifications</h3>
        <p className="room-settings-description">
          Notification settings will be implemented in a future update.
        </p>
        <div className="notifications-placeholder">
          <ion-icon name="notifications-outline" />
          <span>Coming soon</span>
        </div>
      </div>
    </div>
  );
};

export default NotificationsPage;
